module.exports = __webpack_public_path__ + "img/big_flug_deactive.ce5fb3a3.svg";